import React, { useState } from "react";

const handleChildrenType = (children) => {
  if (typeof children === 'string') return 'str'
  else if (React.isValidElement(children) && children.type === 'p') return 'singleTag'
  else if (React.Children.count(children) > 0) return 'multiTag'
  return 'unknown';
};

const truncateChildren = (children, maxLength, byParagraphs) => {
  if (byParagraphs) return children.slice(0,maxLength);
  let totalLength = 0;
  let truncatedChildren = [];

  for (let i = 0; i < React.Children.count(children); i++) {
    const child = React.Children.toArray(children)[i];

    if (React.isValidElement(child) && typeof child.props.children === 'string') {
      const childText = child.props.children;
      const childLength = childText.length;

      if (totalLength + childLength > maxLength) {
        const truncatedText = childText.slice(0, maxLength - totalLength);
        truncatedChildren.push(
          React.cloneElement(child, {
            children: truncatedText,
          })
        );
        break; // Break out of the loop after truncating the child
      }
      totalLength += childLength;
      truncatedChildren.push(child);
    }
  }

  return truncatedChildren;
};

const truncateChild = (children, maxLength) => {
    const childText = children.props.children;

    let truncatedChildren = null;
    if (typeof childText === 'string') {
      truncatedChildren = React.cloneElement(children, {children: childText.slice(0, maxLength),});
      return truncatedChildren;
    }

    return children;
}

const truncateParagraphs = (children, maxLength, byParagraphs) => {
  let textType = handleChildrenType(children);

  if (textType == 'str') return children.slice(0, maxLength);
  if (textType == 'singleTag') return truncateChild(children, maxLength);
  if (textType == 'multiTag') return truncateChildren(children, maxLength, byParagraphs);

  return children;
};

const childrenLength = (children, byParagraphs) => {
  if (byParagraphs) return children.length;
  let totalLength = 0;

  React.Children.forEach(children, (child) => {
    if (React.isValidElement(child) && typeof child.props.children === 'string') {
      const childText = child.props.children;
      totalLength += childText.length;
    }
  });

  return totalLength;
}

const greaterThanMax = (children, maxLength, byParagraphs) => {
  let textType = handleChildrenType(children);

  if (textType == 'str') return children.length > maxLength;
  if (textType == 'singleTag') return children.props.children.length > maxLength;
  if (textType == 'multiTag') return childrenLength(children, byParagraphs) > maxLength;

  return false;
};

const lessThanMax = (children, maxLength, byParagraphs) => {
  let textType = handleChildrenType(children);

  if (textType == 'str') return children.length <= maxLength;
  if (textType == 'singleTag') return children.props.children.length <= maxLength;
  if (textType == 'multiTag') return childrenLength(children, byParagraphs) <= maxLength;

  return false;
 
};

const LongText = ({ maxLength, children, disable, byParagraphs=false, callBack=null }) => {
  if (disable) return <div className="long-text-container">{children}</div>
  const [showFullText, setShowFullText] = useState(lessThanMax(children, maxLength, byParagraphs));

  const handleToggleText = () => {
    setShowFullText(!showFullText);
    if (callBack) showFullText ? callBack.call(callBack.fullText) : callBack.call(callBack.truncatedText);
  };

  const truncatedText = showFullText ? children: truncateParagraphs(children, maxLength, byParagraphs);

  return (
    <div className="long-text-container">
      <div className="truncated-text">{truncatedText}
      {greaterThanMax(children, maxLength, byParagraphs) && (
        <strong className="more-button" onClick={handleToggleText}>
          {showFullText ? "Show less" : "...show more"}
        </strong>
      )}
     </div>
    </div>
  );
};

export default LongText;